import { render, staticRenderFns } from "./CargoForm.vue?vue&type=template&id=54297349"
import script from "./CargoForm.vue?vue&type=script&lang=js"
export * from "./CargoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports